import { IConfig } from 'app/config'
import { RootStore } from 'service/RootStore'
import { LanguageISO } from 'utils/localisation'

declare global {
  interface Window {
    app: RootStore
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
    renderFortoX: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
    unmountFortoX: any
    config: IConfig
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
    grecaptcha: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
    fullstory: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
    dataLayer: any[]
    userlaneSettings: {
      app_id: number
      user: { id: string }
      lang: LanguageISO
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
    Userlane: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
    Cypress: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
    TraceKit: any
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
  const __webpack_share_scopes__: any
  interface EventTarget {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
    value?: any
    checked?: boolean
  }
  namespace __MaterialUI {
    interface TextFieldProps {
      readOnly?: boolean
    }
    interface FlatButtonProps {
      id?: string
    }
    interface RaisedButtonProps {
      id?: string
    }
    interface SliderProps {
      className?: string
    }
    interface SubheaderProps {
      className?: string
    }
    interface CircularProgressProps {
      className?: string
    }
    namespace DatePicker {
      interface DatePickerProps {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
        required?: any
      }
    }
    namespace Menus {
      interface MenuProps {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
        onMouseDown?: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
        onMouseEnter?: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
        onMouseLeave?: any
        className?: string
      }
      interface DropDownMenuProps {
        autoWidth?: boolean
      }
    }
  }
}

/*
Added below line to fix betterer failure "Property 'Cypress' does not exist on type 'Window & typeof globalThis'."
https://github.com/freight-hub/freighthub-ship/pull/2359#discussion_r824830449
*/
window.Cypress = window.Cypress || undefined
window.dataLayer = window.dataLayer || []
window.grecaptcha = window.grecaptcha || undefined
window.config = window.config || ({} as IConfig)

export {}
